const BOOLEAN_STRINGS: any = { true: true, false: false };
export const formatValue = (value: any) => {
  // Convert string of boolean to actual boolean
  if (value === null) {
    return null;
  }
  if (value === true || value === false) {
    return value;
  }
  if (!isNaN(Number(value))) {
    if (value && value.length && value[value.length - 1] === '.') {
      // The value is technically a number, but return it as a
      // string to preserve the trailing "."
      return value;
    }
    return Number(value);
  }
  if (value && value.toLowerCase) {
    const lowercaseValue: string = value.toLowerCase();
    const formattedValue = BOOLEAN_STRINGS[lowercaseValue];
    return formattedValue !== undefined ? formattedValue : value;
  }
  return value;
};
